import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { LettersApi, type GetLettersResponse } from '@shared/api';

interface UseLettersStore {
  loading: boolean;
  data: GetLettersResponse[];
  error: string | null;
  getLetters: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useLettersStore = create<UseLettersStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getLetters: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await LettersApi.getLetters(signal);
      set({ data: result ?? [], loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
